export const TRAVELER_ACTIVITY = 'traveler activity';
export const INVITE_GUEST_RESEND = 'invite guests resend';
